require('./bootstrap');

window.Noty = require('noty');

window.Project = require('./project');

// Run the hello() function
Project.hello();
